<template>
    <div>
        <header class="logo col-12 p-2">
            <img class="col-12" :src="logo" />
        </header>
        <div class="row p-2 justify-content-center">
            <div class="col-auto p-1">
                <router-link class="btn p-2" to="/formacoes">
                    <i class="fa fa-list fa-2x"></i>
                </router-link>
            </div>
            <div class="col-auto p-1">
                <router-link class="btn p-2" to="/treinos">
                    <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 512 512"
                        color="#333"
                        height="30"
                        width="30"
                        xmlns="http://www.w3.org/2000/svg"
                        style="color: rgb(51, 51, 51)"
                    >
                        <path
                            d="M128 29.5c-6.557 0-12.898 3.62-18.146 10.924C104.604 47.728 101 58.51 101 70.596c0 12.085 3.605 22.866 8.854 30.17 5.248 7.303 11.59 10.923 18.146 10.923 6.557 0 12.898-3.62 18.146-10.924 5.25-7.304 8.854-18.085 8.854-30.17 0-12.086-3.605-22.868-8.854-30.172C140.898 33.12 134.556 29.5 128 29.5zm256 0c-6.557 0-12.898 3.62-18.146 10.924C360.604 47.728 357 58.51 357 70.596c0 12.085 3.605 22.866 8.854 30.17 5.248 7.303 11.59 10.923 18.146 10.923 6.557 0 12.898-3.62 18.146-10.924 5.25-7.304 8.854-18.085 8.854-30.17 0-12.086-3.605-22.868-8.854-30.172C396.898 33.12 390.556 29.5 384 29.5zm-235.736 93.912c-5.99 3.932-12.87 6.277-20.264 6.277-7.25 0-13.996-2.26-19.902-6.053l-2.67 2.67c.905 4.4 3.467 9.56 7.77 15.298 3.93 5.24 9.223 10.835 14.802 16.532 5.58-5.697 10.87-11.292 14.8-16.532 4.402-5.868 6.963-11.122 7.81-15.584l-2.346-2.608zm215.472 0l-2.345 2.61c.846 4.46 3.408 9.715 7.81 15.583 3.93 5.24 9.22 10.835 14.8 16.532 5.58-5.697 10.87-11.292 14.8-16.532 4.305-5.74 6.867-10.9 7.772-15.298l-2.67-2.67c-5.906 3.792-12.653 6.052-19.902 6.052-7.395 0-14.273-2.346-20.264-6.278zM88.998 134.826l-31.93 10.643c.077 28.387 1.13 55.42 13.496 82.132 43.338 13.938 71.534 13.938 114.872 0 12.367-26.712 13.42-53.745 13.496-82.133l-31.93-10.644c-2.11 6.28-5.692 12.1-9.803 17.58-6.577 8.768-14.837 16.963-22.837 24.963L128 183.733l-6.363-6.365c-8-8-16.26-16.196-22.836-24.964-4.11-5.48-7.693-11.3-9.802-17.58zm256 0l-31.93 10.643c.077 28.387 1.13 55.42 13.496 82.132 43.338 13.938 71.534 13.938 114.872 0 12.367-26.712 13.42-53.745 13.496-82.133l-31.93-10.644c-2.11 6.28-5.692 12.1-9.803 17.58-6.577 8.768-14.837 16.963-22.837 24.963L384 183.733l-6.363-6.365c-8-8-16.26-16.196-22.836-24.964-4.11-5.48-7.693-11.3-9.802-17.58zM18 146.5v36h22.44c-1.203-12.188-1.39-24.202-1.422-36H18zm198.982 0c-.03 11.798-.22 23.812-1.42 36h80.878c-1.203-12.188-1.39-24.202-1.422-36h-78.036zm256 0c-.03 11.798-.22 23.812-1.42 36H494v-36h-21.018zM73 247.24v63.45c5.94 4.56 14.298 7.316 23 7.316 8.627 0 17.07-2.6 23-7.086v-27.914h18v27.914c5.93 4.487 14.373 7.086 23 7.086 8.702 0 17.06-2.757 23-7.317v-63.45c-39.33 11.437-70.67 11.437-110 0zm256 0v63.45c5.94 4.56 14.298 7.316 23 7.316 8.627 0 17.07-2.6 23-7.086v-27.914h18v27.914c5.93 4.487 14.373 7.086 23 7.086 8.702 0 17.06-2.757 23-7.317v-63.45c-39.33 11.437-70.67 11.437-110 0zm-210 84.252c-7.228 3.056-15.142 4.514-23 4.514-7.847 0-15.77-1.42-23-4.45v27.364c5.93 4.487 14.373 7.086 23 7.086s17.07-2.6 23-7.086v-27.428zm18 0v27.428c5.93 4.487 14.373 7.086 23 7.086s17.07-2.6 23-7.086v-27.363c-7.23 3.03-15.153 4.45-23 4.45-7.858 0-15.772-1.46-23-4.515zm238 0c-7.228 3.056-15.142 4.514-23 4.514-7.847 0-15.77-1.42-23-4.45v27.364c5.93 4.487 14.373 7.086 23 7.086s17.07-2.6 23-7.086v-27.428zm18 0v27.428c5.93 4.487 14.373 7.086 23 7.086s17.07-2.6 23-7.086v-27.363c-7.23 3.03-15.153 4.45-23 4.45-7.858 0-15.772-1.46-23-4.515zm-274 48c-7.228 3.056-15.142 4.514-23 4.514-6.4 0-12.813-1.076-18.898-3.068 1.1 3.693 2.132 7.308 3.437 11.222 2.93 8.792 6.073 17.492 7.564 25.846H119v-38.514zm18 0v24.373c4.736-7.94 11.14-14.775 18.723-20.02-6.43-.438-12.806-1.85-18.723-4.353zm238 0c-7.228 3.056-15.142 4.514-23 4.514-6.4 0-12.813-1.076-18.898-3.068 1.1 3.693 2.132 7.308 3.437 11.222 2.93 8.792 6.073 17.492 7.564 25.846H375v-38.514zm18 0v38.514h30.896c1.49-8.354 4.634-17.054 7.565-25.846 1.306-3.914 2.34-7.53 3.438-11.223-6.085 1.993-12.497 3.07-18.898 3.07-7.858 0-15.772-1.46-23-4.515zM192 390.5c-25.512 0-46 20.488-46 46s20.488 46 46 46 46-20.488 46-46-20.488-46-46-46zM89 436.006v44h56.156C134.526 468.57 128 453.274 128 436.5c0-.166.01-.33.012-.494H89zm256 0v44h78v-44h-78z"
                        ></path>
                    </svg>
                </router-link>
            </div>

            <div class="col-auto p-1">
                <button class="btn p-2" @click="logout">
                    <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        color="#333"
                        height="30"
                        width="30"
                        xmlns="http://www.w3.org/2000/svg"
                        style="color: rgb(51, 51, 51)"
                    >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                        ></path>
                    </svg>
                </button>
            </div>
            <div class="col-auto p-1">
                <router-link class="btn p-2" to="/profile">
                    <i class="fa fa-user-alt fa-2x"></i>
                </router-link>
            </div>
            <div class="col-auto p-1">
                <router-link class="btn p-2" to="/videos">
                    <i class="fa fa-play fa-2x"></i>
                </router-link>
            </div>

            <div
                class="row p-2 m-0 justify-content-center col-12 col-sm-10"
                v-if="notifys"
            >
                <div
                    class="alert alert-default col-12 p-2"
                    v-for="(notify, index) in notifys"
                    :key="notify.id"
                    :style="{ background: notify.background }"
                >
                    <i
                        class="fa fa-times close"
                        @click="hideNotify(index)"
                        v-if="index != deleting"
                    ></i>
                    <i class="fa fa-sync fa-spin close disabled" v-else></i>
                    <i
                        :class="'icon fa fa-2x ' + notify.icon"
                        :style="{ color: notify.color }"
                    ></i>
                    <h3
                        class="icon d-inline-block p-1 pt-0 mt-0"
                        :style="{ color: notify.color }"
                    >
                        {{ notify.title }}
                    </h3>
                    <hr class="m-0" />
                    <div :style="{ color: notify.color }" class="p-2">
                        {{ notify.message }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { t } from "@/lang";
import { mapActions, mapMutations } from "vuex";
export default {
    name: "HomeView",
    data() {
        return {
            logo: "/images/logo.jpg",
            notifys: null,
            deleting: -1,
        };
    },
    async created() {
        this.getNotifys();
    },
    methods: {
        t,
        ...mapMutations(["SET_LOADING"]),
        ...mapActions(["post", "get"]),
        async logout() {
            this.SET_LOADING(true);
            try {
                const response = await this.post({
                    url: "auth/logout",
                });
                console.log(response);
                sessionStorage.removeItem("auth_token");
                location = "/login";
            } catch (e) {
                alert(e.data.message);
            }
            this.SET_LOADING(false);
        },
        async getNotifys() {
            this.SET_LOADING(true);
            const res = await this.get({ url: "notifications" });
            if (res.status == 200) {
                this.notifys = res.data.notifications;
                console.log(this.notifys);
            } else {
                console.log(res.data);
                alert(res.data.message);
            }
            this.SET_LOADING(false);
        },
        async hideNotify(index) {
            this.deleting = index;
            const n = this.notifys[index];
            const res = await this.post({ url: `notifications/${n.id}` });
            console.log(res.data);
            if (res.status == 200) {
                this.notifys.splice(index, 1);
            } else {
                console.log(res.data);
                alert(res.data.message);
            }
            this.deleting = -1;
        },
    },
};
</script>

<style scoped>
.btn {
    background-color: white;
    box-shadow: 0px 0px 2px blanchedalmond;
    border: none;
    width: 50px;
    height: 50px;
}
.btn:hover {
    background-color: #d0d0d0;
}
</style>
